import { defineStore } from 'pinia';
import { apiClient } from '@/Clients/ApiClient';
import ProjectLanguageConfigurationService from '@/Services/Admin/ProjectLanguageConfigurationService';

const projectLanguageConfigurationService = new ProjectLanguageConfigurationService(apiClient);

export const useProjectTranslationsStore = defineStore({
    id: 'projectTranslations',
    state: () => ({
        projectId: null,
        selectedProjectLanguageId: 1,
        languages: [],
    }),
    actions: {
        setProjectLanguage(languageId) {
            this.selectedProjectLanguageId = languageId;
        },
        setProjectLanguages(languages) {
            this.languages = languages;
        },
        setProjectDefaultLanguage() {
            const defaultLanguage = this.languages.find(x => x.isDefault);
            if (defaultLanguage) {
                this.setProjectLanguage(defaultLanguage.languageID);
            }
            else {
                this.setProjectLanguage(null);
            }
        },
        async loadProjectLanguagesConfiguration(projectID, forceUpdate = false) {
            if (this.projectId === projectID && !forceUpdate) {
                return this.languages;
            }
            this.projectId = projectID;
            const response = await projectLanguageConfigurationService
                .getProjectLanguagesConfiguration({ projectID });

            this.setProjectLanguages(response.data);
            this.setProjectDefaultLanguage();
            return this.languages;
        },
    },
    getters: {
        selectedProjectLanguage() {
            return this.languages.find(x => x.languageID === this.selectedProjectLanguageId);
        },
        selectedProjectLanguageIsoCode() {
            if (this.selectedProjectLanguage) {
                return this.selectedProjectLanguage.languageIsoCode;
            }
            return null;
        },
        selectedProjectLanguageName() {
            if (this.selectedProjectLanguage) {
                return this.selectedProjectLanguage.languageName;
            }
            return null;
        },
        hasAvailableLanguages() {
            return this.languages.filter(i => i.isEnabled).length > 1;
        },
    },
});